import React, { useState, useEffect } from 'react';
import { Modal, Box, Typography, TextField, Button, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { CustomAlert, showToastAlert } from "../../admin/components/CustomAlert";
import { useSelector } from 'react-redux';
import { addMailOrganization, updateMailOrganization } from '../../services/writerPost';


const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 360,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

export function MailModal({ open, onClose, onCreate, onUpdate, company = null }) {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [targetType, setTargetType] = useState('company'); // 'company' or 'college'
  const [organization, setOrganization] = useState(''); // <-- added state
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const token = useSelector(state => state.token);

  useEffect(() => {
    if (company && typeof company === 'object') {
      // If caller passes an object, prefill name/email/organization when available
      setName(company.name || '');
      setEmail(company.email || '');
      setOrganization(company.organization || ''); // <-- prefill organization
      // keep targetType default unless specified
      if (company.type) setTargetType(company.type);
    } else if (!open) {
      // reset on close
      setName('');
      setEmail('');
      setTargetType('company');
      setOrganization(''); // <-- reset organization
      setError(null);
    }
  }, [company, open]);

  const handleCreate = async () => {
    if (!email.trim() || !targetType) {
      window.alert("Please fill all required fields.");
      return;
    }
    setError(null);
    setLoading(true);
    try {
      const payload = {
        name: name.trim(),
        email: email.trim(),
        type: targetType,
        organization: organization.trim(), // <-- include organization in payload
      };

      let response = null;
     
      if(company != null) 
        response = await updateMailOrganization(token, { ...payload, id: company._id });
      else
        response  = await addMailOrganization(token, payload);


      if(response.status !== 200) {
        showToastAlert(response.data.message, "error");
        return;
      }
      if(company != null)
        onUpdate();
      else
        onCreate();
      
      setError(null);
      setLoading(false);
      showToastAlert("Action submitted", "success");
      // reset and close
      setName('');
      setEmail('');
      setTargetType('company');
      setOrganization(''); // <-- reset organization
      onClose();
    } catch (err) {
      setError(err.message || "Failed to submit");
      showToastAlert(err.message || "Failed to submit", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={style}>
        <Typography variant="h6" component="h2" gutterBottom>
          Compose Mail
        </Typography>

        <FormControl fullWidth sx={{ mb: 2 }}>
          <InputLabel id="mail-target-type-label">Select Type</InputLabel>
          <Select
            labelId="mail-target-type-label"
            value={targetType}
            label="Select Type"
            onChange={(e) => setTargetType(e.target.value)}
          >
            <MenuItem value="company">Company</MenuItem>
            <MenuItem value="college">College</MenuItem>
          </Select>
        </FormControl>
        <TextField
          label="Email"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          fullWidth
          sx={{ mb: 2 }}
        />

        {/* Organization Name field */}
        <TextField
          label="Organization Name"
          value={organization}
          onChange={(e) => setOrganization(e.target.value)}
          fullWidth
          sx={{ mb: 2 }}
        />

        {error && <Typography color="error" sx={{ mb: 1 }}>{error}</Typography>}

        <Button variant="contained" onClick={handleCreate} fullWidth disabled={loading}>
          {loading ? "Please wait..." : (company ? "Update" : "Save")}
        </Button>

        <CustomAlert />
      </Box>
    </Modal>
  );
}
